<template>
    <div class="myinfo password">
        <div class="admin-info">
            <el-form :model="passwordForm" status-icon :rules="rules" ref="passwordForm" label-width="68px">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input type="password" v-model="passwordForm.oldPassword" autocomplete="off" maxlength="18"
                              show-word-limit placeholder="请输入旧密码" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="passwordForm.password" autocomplete="off" maxlength="18"
                              show-word-limit placeholder="请输入新密码" show-password></el-input>
                </el-form-item>
                <el-form-item label="二次密码" prop="password2">
                    <el-input type="text" v-model="passwordForm.password2" autocomplete="off" maxlength="18"
                              show-word-limit placeholder="请再次输入新密码" show-password></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="code">
                    <el-input type="text" v-model="passwordForm.code" autocomplete="off" maxlength="6"
                              placeholder="请输入验证码" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="fc-fr" @click="resetForm('passwordForm')" :style="'width: 25%;'">重置</el-button>
                    <el-button class="" type="primary" @click="submitForm('passwordForm')" :style="'width: 70%;'">修改</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Password",
        data(){
            let checkOldPassword = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请输入旧密码'));
                    }else{
                        callback();
                    }
                },500);
            };
            let checkPassword = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请输入新密码'));
                    }else if (value.length < 6 || value.length > 18){
                        callback(new Error('密码在6~18个长度内'));
                    }else if (RegExp("[ ]").test(value)){
                        callback(new Error('密码不能包含空格'));
                    }else if(value === this.passwordForm.oldPassword){
                        callback(new Error('新、旧密码不能一致'));
                    }else{
                        callback();
                    }
                },500);
            };
            let checkPassword2 = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请再次输入新密码'));
                    }else if(value !== this.passwordForm.password){
                        callback(new Error('两次密码不一致'));
                    }else {
                        callback();
                    }
                }, 500);
            };
            let checkCode = (rule, value, callback) => {
                setTimeout(() => {
                    if (value === '' || value === null) {
                        callback(new Error('请输入验证码'));
                    }else {
                        callback();
                    }
                }, 500);
            };
            return{
                //密码表单
                passwordForm: {
                    oldPassword: '',
                    password: '',
                    password2: '',
                    code: ''
                },
                //验证规则
                rules: {
                    oldPassword: [{ validator: checkOldPassword, trigger: 'blur' }],
                    password: [{ validator: checkPassword, trigger: 'blur' }],
                    password2: [{ validator: checkPassword2, trigger: 'blur' }],
                    code: [{ validator: checkCode, trigger: 'blur' }],
                },
            }
        },
        created(){
        },
        mounted(){
        },
        methods: {
            submitForm(formName) {
                this.$loading.show();
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$loading.close();
                        const passwordForm = {
                            oldPassword: this.passwordForm.oldPassword,
                            password: this.passwordForm.password,
                            googleCode: this.passwordForm.code
                        }
                        this.$axios.post({
                            url: '/adminInfo/password/update',
                            data: passwordForm,
                            success: (res) => {
                                switch (res.code) {
                                    case 0: {
                                        this.resetForm(formName);
                                        this.$alert('密码修改成功,请重新登录', '修改成功', {
                                            confirmButtonText: '确定',
                                            callback: () => {
                                                window.localStorage.removeItem('adminToken');
                                                location.href = this.feUrl + '/login.html';
                                                //this.$router.push(this.feUrl + '/login.html');
                                            }
                                        });
                                        break;
                                    }
                                    default : {
                                        this.$alert(res.msg, '修改失败', {
                                            confirmButtonText: '确定'
                                        });
                                        break;
                                    }
                                }
                            },
                            error: () => {
                                this.$message.error('出错了');
                            }
                        });
                    } else {
                        this.$loading.close();
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
        }
    }
</script>

<style scoped>

</style>
